import type { FC } from 'react';
import classnames from 'classnames';
import type { PapiUser } from '@wix/da-papi-types';
import UserBirthdayBanner from './UserBirthdayBanner';
import GroupBirthdayBanner from './GroupBirthdayBanner';

import s from './BirthdayBanner.scss';

interface Props {
  user: PapiUser;
  className?: string;
}

const BirthdayBanner: FC<Props> = ({ className, user }) => {
  if (user.isGroup) {
    return <GroupBirthdayBanner className={classnames(s['root'], className)} user={user} />;
  }
  return <UserBirthdayBanner className={classnames(s['root'], className)} user={user} />;
};

BirthdayBanner.displayName = 'BirthdayBanner';

export default BirthdayBanner;
